module.exports = __webpack_public_path__ + "static/media/social_insta.35919435.svg";